import $ from 'jquery';

export const showSpinner = () => {
  $('.app-spinner').fadeIn();
};
